/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/bqa/"

const bqa: CommunityData = {
  code: "bqa",
  inviteCode: "berlinqueeragenda",
  name: "BQA",
  thumbnail: "",
  favicon: "",
  waitlist: false,
  defaultCurrency: "EUR",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/bqa-030`,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#f4acdf",
      hero: {
        desktop: `${S3_PREFIX}mobile-landing-background.jpg`,
        mobile: `${S3_PREFIX}mobile-landing-background.jpg`,
        style: "bg-[#e88ac9]",
      },
      logo: {
        desktop: `${S3_PREFIX}logo.png`,
        mobile: `${S3_PREFIX}logo.png`,
        style: "w-[130px] h-[100px] sm:w-[160px] sm:h-[120px]",
      },
      werzLogoColor: "#191818",
      title: "font-['Sixtyfour'] text-[20px] leading-[125%] text-[#111111]",
      text: "font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-[#111111]",
      button:
        "font-['Sixtyfour'] text-[12px] leading-[125%] p-4 rounded-[8px] bg-[#111111] text-[#ffffff] cursor-pointer w-fit",
      input: {
        base: "font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] leading-[120%] w-[256px] rounded-[8px] px-4 h-[48px] bg-white text-[#111111]",
        border: "#000000",
        borderFocus: "#111111",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error:
        "font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] leading-[120%] text-[#FF0000]",
      footerText:
        "font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] leading-[120%] text-[#111111] text-opacity-50",
      skipButton:
        "font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] leading-[120%] text-[#111111] text-opacity-50 cursor-pointer",
      modal: {
        container: "bg-[#f4acdf] px-[40px] py-[48px]",
        title: "font-['Sixtyfour'] text-[15px] leading-[125%] text-[#111111] text-center",
        text: "font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] leading-[120%] text-[#111111] text-opacity-50 text-center",
        width: "w-[358px]",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#111111] bg-white font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center",
        otpBorder: "#000000",
        otpBorderFocus: "#111111",
      },
    },
    global: {
      mobileOnly: true,
      counterColor: "#000000",
      logo: {
        src: `${S3_PREFIX}community-icon.png`,
        styles: "w-[96px] h-[96px] object-contain",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}logo.png`,
        styles: "w-[160px] h-[120px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#f4acdf",
      asideBg: "#f4acdf",
      asideStyles: "border-r border-[#000000]",
      contentBg: "#f4acdf",
      contentBoxShadow: "",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background.jpg`,
      mainFont: "font-['Sixtyfour']",
      primaryButton:
        "bg-[#111111] border border-[#111111] rounded-[8px] px-[18px] py-[18px] !text-[#ffffff] font-['Sixtyfour'] uppercase !text-[12px] text-left leading-[125%]",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#000000]",
      item: "font-['Sixtyfour'] uppercase text-[14px] text-[#000000] text-left leading-[125%] gap-x-[10px] text-opacity-50 text-center border-b border-[#000000] !pl-0 !py-3",
      itemSelected: "!text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#f4acdf] border border-[#000000] !pb-8",
      titles: "text-[#111111] font-['Sixtyfour'] text-[30px] text-left leading-[125%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] text-center leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#111111] font-['Sixtyfour'] text-[30px] text-left leading-[125%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#111111] font-['Sixtyfour'] text-[11px] text-left leading-[125%]",
          subtitle:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#000000]",
        sectionTitle:
          "text-[#111111] font-['Sixtyfour'] text-[30px] text-left leading-[125%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#111111] font-['Sixtyfour'] text-[11px] text-left leading-[125%]",
          subtitle:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] text-left leading-[120%] mt-2",
          location:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] text-left leading-[120%] mt-1",
          date: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#111111] font-['Sixtyfour'] text-[15px] text-left leading-[125%]",
        text: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#111111] font-['Sixtyfour'] text-[30px] text-left leading-[125%] !mb-4 sm:mb-6",
      },
    },
    shopProductV2: {
      container: "flex flex-col !bg-[#f4acdf] border border-[#000000] sm:p-8 p-4",
      media: "w-full !h-[220px] sm:!h-[280px] object-cover object-top border border-[#000000]",
      mediaContainer: "w-full overflow-hidden",
      title:
        "text-[#111111] font-['Sixtyfour'] text-[20px] sm:text-[20px] text-left leading-[125%] mt-6",
      additionalDetails:
        "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] sm:text-[15px] text-left leading-[120%] mt-4",
      priceSection: "border-t border-[#000000] mt-6 pt-6",
      displayPrice: "text-[#111111] font-['Sixtyfour'] text-[15px] text-left leading-[125%]",
      shortTerms:
        "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.52px] text-[13px] text-left leading-[120%] mt-2 opacity-70",
      button:
        "!bg-[#111111] !border-[#111111] rounded-[8px] px-[18px] py-[18px] !text-[#ffffff] font-['Sixtyfour'] uppercase !text-[12px] text-left leading-[125%] !w-fit self-start",
    },
    linktree: {
      bgDesktop: "https://media.werz.at/community-assets/bqa/web-background.jpg",
      bgMobile: "https://media.werz.at/community-assets/bqa/web-background.jpg",
      bgColor: "#f4acdf",
      bgMedia: "object-cover object-center",
      container:
        "flex flex-col items-center h-full w-full bg-center bg-cover bg-no-repeat min-h-screen relative px-4 py-12 sm:p-[64px] bg-[#f4acdf]",
      communityInfo: {
        logo: "h-[128px] w-[128px] rounded-full border border-[2.5px] object-cover border border-[#000000]",
        name: "text-[#000000] font-['Sixtyfour'] text-[30px] leading-[125%] text-center text-center mt-4 mb-1",
        location: "font-['Sixtyfour'] leading-[125%] text-[11px] text-center text-center mb-2",
        description:
          "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center text-center mb-4 max-w-[500px]",
        socialMediaIconColor: "#000000",
        button:
          "bg-[#fff8eb] border border-[#000000] rounded-[8px] px-[12px] py-[12px] text-[#000000] font-['Sixtyfour'] text-[10px] text-left leading-[125%] w-fit cursor-pointer",
      },
      upcomingEvents: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center justify-center bg-[#f4acdf] border border-[#000000] text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center",
        emptyState: {
          container:
            "sm:w-[500px] w-[95vw] flex flex-col justify-center items-center p-[34px] mb-[32px] bg-[#f4acdf] border border-[#000000]",
          title: "font-['Sixtyfour'] leading-[125%] text-[11px] text-left text-center mb-1",
          text: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center text-center",
          button:
            "bg-[#fff8eb] border border-[#000000] rounded-[8px] px-[12px] py-[12px] text-[#000000] font-['Sixtyfour'] text-[10px] text-left leading-[125%] w-fit cursor-pointer mt-4",
        },
        header:
          "text-[#000000] font-['Sixtyfour'] leading-[125%] text-[11px] text-left text-center mb-[10px]",
        container: "sm:w-[500px] w-[95vw] gap-4 flex flex-col items-center overflow-hidden",
        collapsedEvent: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#f4acdf] border border-[#000000]",
          duration:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
          name: "text-[#111111] font-['Sixtyfour'] leading-[125%] text-[11px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          plusIconColor: "#000000",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        event: {
          container: "overflow-hidden sm:w-[500px] w-[95vw] bg-[#f4acdf] border border-[#000000]",
          name: "text-[#111111] font-['Sixtyfour'] leading-[125%] text-[11px] text-left mb-1 one-line-truncate sm:w-[370px] w-[60vw]",
          startDate:
            "w-[68px] h-[68px] flex flex-col justify-center items-center gap-1 bg-[#f4acdf] border border-[#000000] font-['Sixtyfour'] leading-[125%] text-[10px] text-center",
          duration:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
          location:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
          button:
            "bg-[#fff8eb] border border-[#000000] rounded-[8px] px-[12px] py-[12px] text-[#000000] font-['Sixtyfour'] text-[10px] text-left leading-[125%] w-fit cursor-pointer mt-3",
          product: {
            container:
              "min-h-[68px] px-4 py-3 flex justify-between gap-4 border-t border-[#000000]",
            name: "text-[#111111] font-['Sixtyfour'] leading-[125%] mb-1 text-[10px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
            price: "text-[#111111] font-['Sixtyfour'] leading-[125%] text-[10px] text-left",
            link: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
            status: "text-[#111111] font-['Sixtyfour'] leading-[125%] text-[10px] text-left",
            button:
              "bg-[#fff8eb] border border-[#000000] rounded-[8px] px-[12px] py-[12px] text-[#000000] font-['Sixtyfour'] text-[10px] text-left leading-[125%] w-fit cursor-pointer",
          },
        },
        seeAllEvents:
          "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      news: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center justify-center bg-[#f4acdf] border border-[#000000] text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center",
        header:
          "text-[#000000] font-['Sixtyfour'] leading-[125%] text-[11px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        oneNews: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#f4acdf] border border-[#000000]",
          name: "text-[#111111] font-['Sixtyfour'] leading-[125%] text-[11px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
          triangleIconColor: "#000000",
          created:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
          media: "overflow-hidden m-2 border border-[#000000]",
        },
        seeAllNews:
          "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      radioTracks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center justify-center bg-[#f4acdf] border border-[#000000] text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center",
        header:
          "text-[#000000] font-['Sixtyfour'] leading-[125%] text-[11px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-4",
        radioTrack: {
          container:
            "h-[64px] cursor-pointer sm:w-[500px] w-[95vw] flex justify-between bg-[#f4acdf] border border-[#000000]",
          coverUrl: "overflow-hidden m-2 border border-[#000000]",
          duration:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
          liveType:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
          liveTypeCircle: "w-2 h-2 bg-[#000000] rounded-full",
          playIconColor: "#000000",
          start:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
          title:
            "text-[#111111] font-['Sixtyfour'] leading-[125%] text-[11px] text-left one-line-truncate sm:w-[390px] w-[65vw]",
        },
        seeAllTracks:
          "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center text-center mt-4 cursor-pointer mb-[32px] underline",
      },
      otherLinks: {
        loadingState:
          "mb-[32px] h-[56px] sm:w-[500px] w-[95vw] px-4 flex items-center justify-center bg-[#f4acdf] border border-[#000000] text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.64px] text-[16px] leading-[120%] text-center",
        header:
          "text-[#000000] font-['Sixtyfour'] leading-[125%] text-[11px] text-left text-center mb-[10px]",
        container: "flex flex-col gap-[10px] mb-[40px]",
        link: {
          container:
            "h-[64px] cursor-pointer p-2 sm:w-[500px] w-[95vw] flex justify-between bg-[#f4acdf] border border-[#000000]",
          name: "text-[#111111] font-['Sixtyfour'] leading-[125%] text-[11px] text-left",
          triangleIconColor: "#000000",
          circleIcon: "ml-2 w-[24px] h-[24px] rounded-full object-cover border border-[#000000]",
        },
      },
      footer: {
        WERZlogoColor: "#000000",
        text: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.48px] text-[12px] leading-[120%] mt-2 text-left",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#f4acdf] border border-[#000000] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#000000]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4",
        title: "text-[#111111] font-['Sixtyfour'] text-[20px] text-left leading-[125%]",
        subtitle:
          "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#111111] border border-[#111111] rounded-[8px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#ffffff] font-['Sixtyfour'] uppercase !text-[12px] text-left leading-[125%]",
        questions: "text-[14px] text-left leading-[120%] text-[#111111]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#111111] font-['Sixtyfour'] text-[15px] text-left leading-[125%]",
        text: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#000000]",
        header: "text-[#111111] font-['Sixtyfour'] text-[15px] text-left leading-[125%]",
        text: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#00000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#111111] font-['Sixtyfour'] text-[15px] text-left leading-[125%]",
        text: "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#111111] font-['Sixtyfour'] text-[15px] text-left leading-[125%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4 flex justify-between items-center",
        outerContainer: "flex flex-col !bg-[#f4acdf] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        accessCode: {
          button:
            "bg-[#fff8eb] border border-[#000000] rounded-[8px] px-[12px] py-[12px] text-[#000000] font-['Sixtyfour'] text-[10px] text-left leading-[125%] !w-fit",
        },
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#000000] py-4",
          media: "!hidden",
          mediaContainer: "!hidden",
          name: "text-[#111111] font-['Sixtyfour'] text-[11px] text-left leading-[125%] mb-1",
          description:
            "text-[#111111] font-['CourierPrimeRegular'] tracking-[-0.56px] text-[14px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#111111] font-['Sixtyfour'] text-[11px] text-left leading-[125%]",
          quantity: "text-[#000000] font-['Sixtyfour'] text-[10px] text-left leading-[125%]",
          status: "text-[#111111] font-['Sixtyfour'] text-[11px] text-left leading-[125%]",
          counterContainer:
            "bg-[#fff8eb] border border-[#000000] rounded-[8px] px-[12px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#fff8eb] border border-[#000000] rounded-[8px] px-[12px] py-[12px] text-[#000000] font-['Sixtyfour'] text-[10px] text-left leading-[125%] !w-fit",
          plusMinusColor: "#000000",
        },
      },
    },
  },
}

export default bqa
